import type { ButtonHTMLAttributes } from "react";
import { cn } from "../lib/cn";
import { Icon } from "./icon";

export interface MoreButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	/** `white` — плашка поверх медиа; `transparent` — на белой карточке. */
	surface?: "transparent" | "white";
	state?: "default" | "hover";
	/** Доступное имя кнопки («Ещё»). Обязательно — умолчаний у кита нет. */
	label: string;
}

/**
 * 40×40 триггер «ещё» в правом верхнем углу карточки (DS, figma 1:11).
 * Отдельный компонент, а не SquareBtn с иконкой: у него фиксированный глиф,
 * фиксированная подпись для скринридера и всего два фона.
 */
export function MoreButton({
	surface = "transparent",
	state = "default",
	label,
	className,
	...rest
}: MoreButtonProps) {
	const hovered = state === "hover";
	return (
		<button
			type="button"
			aria-label={label}
			className={cn(
				"inline-flex size-10 shrink-0 items-center justify-center rounded-control text-fg",
				"iec-press",
				"focus-ring",
				surface === "white" ? "bg-card hover:bg-sunken" : "bg-transparent hover:bg-black/4",
				hovered && (surface === "white" ? "bg-sunken" : "bg-black/4"),
				className,
			)}
			{...rest}
		>
			<Icon name="Ellipsis" size={20} />
		</button>
	);
}
